import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=9d5a80e6&"
import script from "./FaqList.vue?vue&type=script&lang=js&"
export * from "./FaqList.vue?vue&type=script&lang=js&"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=9d5a80e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports